import { SerializedStyles } from "@emotion/react";
import { subYears } from "date-fns";
import { Ref, memo, useCallback } from "react";
import { DatePickerCalendar, FormFlowPage } from "src/components";

import { usePartialSubmit } from "../hooks";

export interface DateOfBirthProps {
  value?: Date;
  onChange?: (val?: Date) => void;
  onNext: () => void;
  style?: SerializedStyles;
  focusRef?: Ref<HTMLInputElement>;
  title?: string;
}

const DateOfBirth = ({ value, onChange, onNext, style, title, focusRef, ...props }: DateOfBirthProps) => {
  const validate = useCallback(() => !!value, [value]);
  const { handleNext, nextDisabled, nextLoading } = usePartialSubmit({ onNext, validate });

  return (
    <FormFlowPage
      {...props}
      title={title || "What's your date of birth?"}
      description="Fraction works with people of all ages. Our only requirement is that you are over 18."
      onNext={handleNext}
      nextDisabled={nextDisabled}
      nextLoading={nextLoading}
      style={style}
    >
      <DatePickerCalendar
        label="Date of birth"
        defaultView="decade"
        defaultActiveStartDate={subYears(new Date(), 55)}
        focusRef={focusRef}
        onChange={onChange}
        value={value}
      />
    </FormFlowPage>
  );
};

export default memo(DateOfBirth);
